import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    MarkovRedistributionStateProps,
    LoadMarkovRedistributionStateToById,
    setMarkovRedistributionStateToEdit,
    setMarkovRedistributionStateToReloadEdit,
    initMarkovRedistributionStateTo,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

const Edit = ({
    stateId = null,
}: MarkovRedistributionStateProps) => {
    const redistributionSelected = useSelector((state: StoreType) => state.markovRedistribution.redistributionSelected)

    const redistributionState = useSelector((state: StoreType) => state.markovRedistributionState.to.stateEdit)
    const reloadEdit = useSelector((state: StoreType) => state.markovRedistributionState.to.reloadEdit)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setMarkovRedistributionStateToReloadEdit(false))
        setTimeout(() => {
            dispatch(setMarkovRedistributionStateToReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (stateId === 0) {
            dispatch(setMarkovRedistributionStateToEdit(initMarkovRedistributionStateTo))
            reload()
        } else {
            setLoadState(PENDING)
            LoadMarkovRedistributionStateToById(stateId, redistributionSelected.id).then((res) => {
                dispatch(setMarkovRedistributionStateToEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!redistributionState) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.editRedistributionState}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form redistributionState={redistributionState} />
                }
                {
                    reloadEdit
                    && <Form redistributionState={redistributionState} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
